<template>
  <div
    class="card-wishlist"
    :class="{ 'card-wishlist--active': isOnWishlist }"
    :title="
      isOnWishlist
        ? t('wishlist.productCard.removeFromWishlistLabel')
        : t('wishlist.productCard.addToWishlistLabel')
    "
  >
    <WishlistIcon />
  </div>
</template>

<script setup lang="ts">
import WishlistIcon from '~/assets/icons/wishlist.svg?component'

const { t } = useI18n()

interface Props {
  isOnWishlist?: boolean
}

const { isOnWishlist = false } = defineProps<Props>()
</script>

<style lang="postcss" scoped>
@keyframes heartbeat {
  0%,
  40%,
  80%,
  100% {
    transform: scale(1);
  }
  20%,
  60% {
    transform: scale(1.25);
  }
}

.card-wishlist {
  width: 30px;
  height: 30px;
  right: 4px;
  top: 4px;
  position: absolute;
  cursor: pointer;

  :deep(path) {
    @apply duration-300 ease-in-out;
    fill: transparent;
  }

  &:hover :deep(path) {
    @apply fill-orange-500 stroke-orange-500;
  }

  &--active {
    animation: heartbeat 1s forwards;
    animation-timing-function: ease-in-out;

    :deep(path) {
      @apply fill-orange-500 stroke-orange-500;
    }
  }
}
</style>
